export default __webpack_public_path__ + "media/zurb/img/about/jon/jon-image2-3c07d32055f09870c7519542cd55708f.png";